import {ActionContext, Module} from 'vuex';
import RootState from '@/store/rootState';
import {ProjectDef} from '@/types/Project';
import remote from '@/remote';

export interface ProjectListState {
    list: ProjectDef[];
}

type ProjectListContext = ActionContext<ProjectListState, RootState>;

const projectList: Module<ProjectListState, RootState> = {
    namespaced: true,

    state: {
        list: [],
    },

    actions: {
        async updateList({ commit, rootState }: ProjectListContext): Promise<void> {
            commit('UPDATE_PROJECT_LIST', await remote().userProjectList(rootState.user.user!.uid));
        },

        /*
        async upvoteProject({ commit }, { uid, projectUid, projectName }) {
            commit('setProjectAsFavorite', { uid: projectUid, projectName, value: true });
            await remote.upvoteProject(uid, projectUid, projectName);
        },

        async downvoteProject({ commit }, { uid, projectUid, projectName }) {
            commit('setProjectAsFavorite', { uid: projectUid, projectName, value: false });
            await remote.downvoteProject(uid, projectUid, projectName);
        },
         */
    },

    mutations: {
        UPDATE_PROJECT_LIST(state: ProjectListState, list: ProjectDef[]) {
            state.list = list;
        },

        /*
        setProjectAsFavorite(state, { uid, projectName, value }) {
            for (const project of state.list.filter(p => p.uid === uid && p.name === projectName))
                project.value = value;
        },
         */
    },
};

export default projectList;
